
import APIClient from './APIClient'

class CLeavesAPI {

  async get(id) {
    const res = await APIClient.GET('/leaves/'+id)
    return res
  }

  async delete(id) {
    const res = await APIClient.DELETE('/leaves/'+id)
    return res
  }

  async create({ name, color }) {
    const res = await APIClient.POST('/leaves', {
      name, color
    })
    return res
  }

  async update(id, { name, color }) {
    const res = await APIClient.POST('/leaves/'+id, {
      name, 
      color
    })
    return res
  }

  async list() {
    const res = await APIClient.GET('/leaves')
    return res
  }

}

const LeavesAPI = new CLeavesAPI()

export default LeavesAPI



// WEBPACK FOOTER //
// ./src/api/LeavesAPI.js